import React, { useState, useEffect } from 'react';
import { Button, Modal, Alert } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';

import { hideSuccessAlert } from './duck';

const SuccessAlert = () => {
  const successAlert = useSelector(state => state.successAlert);
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    setTitle(successAlert ? successAlert.title : '');
    setMessage(successAlert ? successAlert.message : '');
  }, [successAlert]);

  const handleHide = () => {
    dispatch(hideSuccessAlert());
  };

  return (
    <Modal
      show={!!title}
      onHide={handleHide}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton id="contained-modal-title-vcenter">
        <h5 className="font-weight-bold">{title}</h5>
      </Modal.Header>
      <Modal.Body>
        <Alert show variant="success">
          <p>{message}</p>
          <hr />
          <div className="d-flex justify-content-end">
            <Button onClick={handleHide} variant="outline-success">
              OK
            </Button>
          </div>
        </Alert>
      </Modal.Body>
    </Modal>
  );
};

export default SuccessAlert;
